import React from "react";
import { Badge, Card, Form, Spinner } from "react-bootstrap";
import { useGetPosStatus, useUpdatePosStatus } from "./api";

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
  gap: "8px",
};

// one mutation per tile, so each toggle tracks its own in-flight request
const PosTile = ({ pos }) => {
  const { mutate, isPending } = useUpdatePosStatus();
  const id = `pos-working-${pos.pos_id}`;
  return (
    <div
      className={
        "d-flex justify-content-between align-items-center rounded-2 border px-3 py-2 " +
        (pos.pos_working ? "bg-body-tertiary" : "bg-danger-subtle border-danger-subtle")
      }
    >
      <label htmlFor={id} className="text-capitalize text-truncate me-2" title={pos.display_name}>
        {pos.display_name}
      </label>
      {isPending ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <Form.Check
          type="switch"
          id={id}
          className="mb-0 pos-switch"
          checked={pos.pos_working}
          onChange={(e) => mutate({ pos_id: pos.pos_id, pos_working: e.target.checked })}
        />
      )}
    </div>
  );
};

const PosGroup = ({ title, list, color }) => (
  <div className="mb-3">
    <div className="small fw-semibold text-uppercase text-body-secondary mb-2">
      <span className={`text-${color} me-1`}>●</span>
      {title} ({list.length})
    </div>
    {list.length ? (
      <div style={gridStyle}>
        {list.map((pos) => <PosTile key={pos.pos_id} pos={pos} />)}
      </div>
    ) : (
      <div className="small text-body-secondary">None</div>
    )}
  </div>
);

const PosStatus = () => {
  const { data = [], isLoading } = useGetPosStatus();
  const working = data.filter((p) => p.pos_working);
  const notWorking = data.filter((p) => !p.pos_working);
  return (
    <div className="px-md-4 mb-4">
      <Card className="text-start">
        <Card.Header className="d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div>
            <div className="fw-semibold">POS Status</div>
            <div className="small text-body-secondary">Turn a POS off while its extraction is down</div>
          </div>
          {!isLoading && (
            <div className="d-flex gap-2">
              <Badge bg="success-subtle" text="success-emphasis" pill>{working.length} Working</Badge>
              <Badge bg="danger-subtle" text="danger-emphasis" pill>{notWorking.length} Not Working</Badge>
            </div>
          )}
        </Card.Header>
        <Card.Body className="pb-1">
          {isLoading ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <>
              {/* broken POS first: that's the list people act on */}
              <PosGroup title="Not Working" list={notWorking} color="danger" />
              <PosGroup title="Working" list={working} color="success" />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PosStatus;
